// Twee klikken voor verzenden: de eerste klik zet de knop een paar seconden "op scherp" (de tekst
// verandert in "Nu verzenden"), de tweede klik binnen die tijd verzendt echt. Zo gaat er geen
// mail weg door één klik te veel; verzenden is de enige actie die niet ongedaan te maken is.

export interface Armed {
  until: number;
}

export const ARM_MS = 6000;

/** Volgende stand na een klik: eerst op scherp zetten, daarna (binnen de tijd) afvuren. */
export function nextArm(current: Armed | null, now: number, ms = ARM_MS): { fire: boolean; state: Armed | null } {
  if (current && current.until > now) return { fire: true, state: null };
  return { fire: false, state: { until: now + ms } };
}

export function isArmed(current: Armed | null, now: number): boolean {
  return !!current && current.until > now;
}
